module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"David Kurniawan","short_name":"David_Kurniawan","description":"I am a software developer with passion in creating apps with the most advanced technologies","lang":"en","start_url":"/","background_color":"#eee","theme_color":"#ae66df","display":"standalone","icon":"static/logo.png","legacy":false,"crossOrigin":"anonymous","theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"7a2c3f5b9057c570f0cde595c147ccb9"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
